/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import _ from 'lodash';
import { Outlet } from 'react-router-dom';
/** Added extra headshots */

function HomeTab() {
  return <Outlet />;
}

export default HomeTab;
